import API from 'utils/api';
import { onError } from 'utils/handlers';

const baseURI = 'catalogos/';

/**
 * GET Codigos postales
 * @param {Object} params
 * @returns {Promise <Array<Object>>}
 */
// eslint-disable-next-line import/prefer-default-export
export const getCodigosPostales = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}codigos-postales/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Estados
 * @returns {Promise <Array<Object>>}
 */
export const getEstados = async () => {
  try {
    const response = await API.get(`${baseURI}estados/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Municipios
 * @param {Object} params
 * @returns {Promise <Array<Object>>}
 */
export const getMunicipios = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}municipios/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catalogo de paises
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCatalogoDePaises = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}catalogos-de-paises/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Content Types Urs
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getContentTypesURs = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}content-types-urs/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
